export enum DeviceStatus {
    AVAILABLE = 'available',
    PREPARING = 'preparing',
    CHARGING = 'charging',
    SUSPENDEDEVSE = 'suspendedevse',
    SUSPENDEDEV = 'suspendedev',
    FINISHING = 'finishing',
    RESERVED = 'reserved',
    UNAVAILABLE = 'unavailable',
    FAULTED = 'faulted'
}

export enum ActivationStatus {
    INACTIVE = 'INACTIVE',
    ACTIVE = 'ACTIVE'
}